import { isRecommendedPackage } from '../packagesUtils';
import { BASIC_PACKAGE_ID } from '../packagesUtils/constants';

const calcDefaultSelectedPackage = (packageList) => {
    let defaultCheckedId = BASIC_PACKAGE_ID;
    packageList.forEach((packageData) => {
        if (isRecommendedPackage(packageData)) {
            defaultCheckedId = packageData.id;
        }
    });

    return defaultCheckedId;
};

export default calcDefaultSelectedPackage;
